// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1174":"31d6cfe0","1483":"c3fc82c1","3508":"84eebfcc"}[chunkId] + ".chunk.css";
};